import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 合作关系
 */
class Partnership extends UltMeta {
    AFFILIATION = new Meta(1, "挂靠");
    OWN = new Meta(2, "自有");
}

export const PARTNERSHIP = new Partnership();

/**
 * 认证状态
 */
class State extends UltMeta {
    PENDING_CERTIFICATION = new Meta(1, "待认证");
    PENDING_REVIEW = new Meta(2, "待审核");
    REJECTED = new Meta(3, "已驳回");
    APPROVED = new Meta(4, "已通过");
    CANCEL = new Meta(5, "已作废");
}

export const STATE = new State();

/**
 * 审核状态
 */
class AuditState extends UltMeta {
    AGREE = new Meta(1, "同意");
    REJECT = new Meta(2, "拒绝");
}
export const AUDIT_STATE = new AuditState();

/**
/**
 * 校验结果类型
 */
class ResultType extends UltMeta {
    ZERO = new Meta(0, "数据异常");
    ONE = new Meta(1, "船舶不存在");
    TWO = new Meta(2, "船舶正常，且船舶与所录船主无运力数据");
    THREE = new Meta(3, "此船舶货主已认证，请勿重复添加");
    FOUR = new Meta(4, "此船舶货主已提交认证，请勿重复添加");
    FIVE = new Meta(5, "此船舶货主已添加认证，暂未提交，是否帮货主新增");
    SIX = new Meta(6, "此船舶已被货主otherOwner认证，无法添加");
    SEVEN = new Meta(7, "此船舶已被货主otherOwner提交认证，确认要添加到货主owner?");
    EIGHT = new Meta(8, "没有跟别的货主的运力数据");
    NINE = new Meta(9, "船舶ship已被货主otherOwner认证，状态：已通过，若需同意审核，请先解绑原货主");
    TEN = new Meta(
        10,
        "船舶ship已被货主xxx提交过认证，状态：待审核，若同意审核本条运力，则货主otherOwner的运力数据将置为已作废"
    );
    ELEVEN = new Meta(11, "您暂未完成个人实名与企业认证，不支持新增船舶");
    TWELVE = new Meta(12, "您暂未完成企业认证，不支持新增船舶");
    THIRTEEN = new Meta(13, "完成个人实名与企业认证");
    FOURTEEN = new Meta(14, "船舶已存在");
    FIFTEEN = new Meta(15, "此船舶货主已添加认证(已作废)，暂未提交，是否帮货主新增");
}
export const RESULT_TYPE = new ResultType();
